export enum GridView {
  LIST = 'LIST',
  TILE = 'TILE',
}

export namespace GridView {
  export function getAll(): GridView[] {
    return [GridView.TILE, GridView.LIST];
  }

  export function getDisplayName(view?: GridView): string {
    switch (view) {
      case GridView.LIST:
        return 'APP.GRID_VIEW.LIST';
      case GridView.TILE:
        return 'APP.GRID_VIEW.TILE';
      default:
        return '';
    }
  }

  export function getIcon(view?: GridView): string {
    switch (view) {
      case GridView.LIST:
        return 'fa-list';
      case GridView.TILE:
        return 'fa-grid-2';
      default:
        return '';
    }
  }
}
